module.exports = "/_next/static/images/CriticalLifeCOVER_Mini-Web-Banner-084cd19be3a92b808e268a5a95f216ba.jpg";